Date.prototype.Format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1, //月份 
        "d+": this.getDate(), //日 
        "h+": this.getHours(), //小时 
        "m+": this.getMinutes(), //分 
        "s+": this.getSeconds(), //秒 
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
        "S": this.getMilliseconds() //毫秒 
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
};

Date.prototype.addDay = function (day) {
    var num = this.getTime();
    num = num + day * 24 * 60 * 60 * 1000;
    return this.setTime(num);

};

Date.prototype.addHour = function (hour) {
    var num = this.getTime();
    num = num + hour * 60 * 60 * 1000;
    return this.setTime(num);
};

Date.prototype.addMin = function (mins) {
    var num = this.getTime();
    num = num + mins * 60 * 1000;
    this.setTime(num);
    return this;
};

Date.prototype.addSec = function (sec) {
    var num = this.getTime();
    num = num + sec * 1000;
    return this.setTime(num);
};



/*
"abcdefg".startsWith("abc")
返回true
*/
String.prototype.startsWith = function (prefix) {
    return this.slice(0, prefix.length) === prefix;
};
/*
"abcdefg".endsWith("efg")
*/
String.prototype.endsWith = function (str) {
    return this.slice(-str.length) == str;
};
/*
去掉字符串两端空格
*/
String.prototype.Trim = function () {
    return this.replace(/(^\s*)|(\s*$)/g, "");
}
//字符串追加
String.prototype.append = function (str) {
    this.__strings__.push(str);
    return this;    //方便链式操作
}

String.prototype.len = function () {
    var len = 0;
    for (var i = 0; i < this.length; i++) {
        var c = this.charCodeAt(i);
        //单字节加1 
        if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
            len++;
        }
        else {
            len += 2;
        }
    }
    return len;
}

String.prototype.format = function (args) {
    var result = this;
    if (typeof (args) == "object") {
        for (var key in args) {
            var reg = new RegExp("({" + key + "})", "gi");
            result = result.replace(reg, args[key]);
        }
    }
    return result;
}



//if (typeof(Object.toJson)!="function") {

//Object.prototype.IsNullOrEmpty = function () {
//    //return JSON.stringify(this);
//    var obj = this;
//    var flag = false;
//    if (obj == null || obj == undefined || typeof (obj) == 'undefined' || obj == '') {
//        flag = true;
//    } else if (typeof (obj) == 'string') {
//        obj = obj.trim();
//        if (obj == '') {//为空  
//            flag = true;
//        } else {//不为空  
//            obj = obj.toUpperCase();
//            if (obj == 'NULL' || obj == 'UNDEFINED' || obj == '{}') {
//                flag = true;
//            }
//        }
//    }
//    else {
//        flag = false;
//    }
//    return flag;
//};
//}



//Array.prototype.toJson = function () {
//    return JSON.stringify(this);
//};


//#endregion


var utils = {
    testEnv() {
        if (typeof wx != 'undefined') {
            return 'wx';
        } else if (typeof test != 'undefined') {
            return 'cyp-ios';
        } else if (typeof test != 'undefined') {
            return 'cyp-android';
        }
    },
    randomString(len) {
        len = len || 32;
        var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
        var maxPos = $chars.length;
        var pwd = '';
        for (var i = 0; i < len; i++) {
            pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
    },
    getQueryStringArgs(key) {
        // 获取查询字符串参数，去除该字符串问号开关符号
        var qs = location.search.length > 0 ? location.search.substring(1) : "",
            args = {},//存放所有查询字符串参数对
            items = qs.split("&"),
            len = items.length,
            name = null,
            value = null;
        if (qs.length == 0) {
            //alert("没有查询字符串,提前退行！");
            return key ? '' : args;
        };
        for (var i = 0; i < len; i++) {
            var item = items[i].split("=");
            name = decodeURIComponent(item[0]);
            value = decodeURIComponent(item[1]);
            args[name] = value;
        }
        if (key) {
            return typeof args[key] != 'undefined' ? args[key] : '';
        } else {
            return args;
        }

    },
    GetQueryString: function (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]); return null;
    },
    //   alert(formatDate("2010-04-30", "yyyy-MM-dd HH:mm:ss"));
    // alert(formatDate("2010-4-29 1:50:00", "yyyy-MM-dd HH:mm:ss"));
    formatDate(date, format) {
        if (!date) return;
        if (!format) format = "yyyy-MM-dd";
        switch (typeof date) {
            case "string":
                date = new Date(date.replace(/-/, "/"));
                break;
            case "number":
                date = new Date(date);
                break;
        }
        if (!date instanceof Date) return;
        var dict = {
            "yyyy": date.getFullYear(),
            "M": date.getMonth() + 1,
            "d": date.getDate(),
            "H": date.getHours(),
            "m": date.getMinutes(),
            "s": date.getSeconds(),
            "MM": ("" + (date.getMonth() + 101)).substr(1),
            "dd": ("" + (date.getDate() + 100)).substr(1),
            "HH": ("" + (date.getHours() + 100)).substr(1),
            "mm": ("" + (date.getMinutes() + 100)).substr(1),
            "ss": ("" + (date.getSeconds() + 100)).substr(1)
        };
        return format.replace(/(yyyy|MM?|dd?|HH?|ss?|mm?)/g, function () {
            return dict[arguments[0]];
        });
    },
    isWeixin() {
        var ua = navigator.userAgent.toLowerCase();
        var isWeixin = ua.indexOf('micromessenger') != -1;
        return isWeixin
    },
    GetGuid() {
        var guid = "";
        for (var i = 1; i <= 32; i++) {
            var n = Math.floor(Math.random() * 16.0).toString(16);
            guid += n;
            if ((i == 8) || (i == 12) || (i == 16) || (i == 20))
                guid += "-";
        }
        return guid;
    },
    // 获取地址栏参数集
    getUrlPramas (url) {
        var url = url || window.location.href;
        var obj = {};
        var reg = /[?&][^?&]+=[^?&]+/g;
        var arr = url.match(reg);
        if (arr) {
            arr.forEach(function (item) {
                var tempArr = item.substring(1).split('=');
                var key = decodeURIComponent(tempArr[0]);
                var val = decodeURIComponent(tempArr[1]);
                obj[key] = val;
            })
        }
        return obj;
    }
};


export default utils



// WEBPACK FOOTER //
// ./src/assets/js/utils.js